export enum LoaderType {
  CIRCLE_NOTCH = 'circle-notch',
  SPINNER = 'spinner',
  SPINNER_THIRD = 'spinner-third',
  LOADER = 'loader',
  }
